import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const NavigationBoldDownIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 6L8 10L12 6' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export default NavigationBoldDownIcon
